// Delegate because Ecomus replaces the drawer contents after each cart change.
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('#CartDrawer form[data-lf-code]');
  if (!form) return;
  event.preventDefault();
  const code = form.elements.code.value.trim();
  const button = form.querySelector('button');
  if (!code || button.disabled) return;
  const drawer = form.closest('#CartDrawer');
  const feedback = drawer.querySelector('.lf-feedback');
  const root = window.Shopify.routes.root;
  button.disabled = true;
  feedback.textContent = '';
  try {
    const current = await fetch(root + 'cart.js');
    if (!current.ok) throw new Error();
    const cart = await current.json();
    const codes = (cart.discount_codes || []).filter(entry => entry.applicable).map(entry => entry.code);
    if (!codes.some(value => value.toLowerCase() === code.toLowerCase())) codes.push(code);
    const sections = [];
    document.dispatchEvent(new CustomEvent('cart:push:section.id', { detail: { sections } }));
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: [...new Set(sections)], sections_url: location.pathname })
    });
    if (!response.ok) throw new Error();
    const updated = await response.json();
    const message = updated.discount_codes?.some(entry => entry.applicable && entry.code.toLowerCase() === code.toLowerCase()) ? form.dataset.success : form.dataset.error;
    document.addEventListener('cart:drawer:render', () => {
      const status = drawer.querySelector('.lf-feedback');
      if (status) status.textContent = message;
    }, { once: true });
    if (updated.sections?.[drawer.getAttribute('section-id')]) {
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: updated, baseEvent: 'discount:update' } }));
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  } catch {
    feedback.textContent = form.dataset.retry;
  } finally {
    button.disabled = false;
  }
});
